import api from '@pray/shared/utils/api';

export type MarketingCampaignStatus =
  | 'draft'
  | 'active'
  | 'paused'
  | 'completed'
  | 'system'
  | 'canceled'
  | 'getting_assets'
  | 'set_to_run';
export type MarketingCampaignBudgetType = 'time_bound' | 'ongoing';
export type MarketingCampaignArchivedFilter = 'false' | 'true' | 'only';
export type MarketingCampaignTableView = 'finops' | 'performance';

export type GetAllMarketingCampaignsParams = {
  artistId: string;
  offset?: number;
  limit?: number;
  sortColumn?: string;
  sortDirection?: 'asc' | 'desc';
  statuses?: MarketingCampaignStatus[] | null;
  budgetType?: MarketingCampaignBudgetType | null;
  productTypes?: string[] | null;
  arStatus?: string[] | null;
  // Derived serving state of an ACTIVE campaign — narrows 'active' only.
  servingStates?: string[] | null;
  archived?: MarketingCampaignArchivedFilter | null;
  search?: string | null;
  dateRangeStart?: string | null;
  dateRangeEnd?: string | null;
  view?: MarketingCampaignTableView | null;
  // Ask for the AR fields on a view that would otherwise skip them. The performance view serves
  // none by default; the CSV export carries AR in both table modes.
  includeAr?: boolean | null;
};

export const getAllMarketingCampaigns = async ({
  artistId,
  offset = 0,
  limit = 20,
  sortColumn = '',
  sortDirection = 'desc',
  statuses = null,
  budgetType = null,
  productTypes = null,
  arStatus = null,
  servingStates = null,
  archived = null,
  search = null,
  dateRangeStart = null,
  dateRangeEnd = null,
  view = null,
  includeAr = null,
}: GetAllMarketingCampaignsParams) => {
  const params: Record<string, string | number> = {};

  if (offset) params.offset = offset;
  if (limit) params.limit = limit;

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  if (statuses && statuses.length > 0) params.status = statuses.join(',');
  if (budgetType) params.budget_type = budgetType;
  if (productTypes && productTypes.length > 0) params.product_type = productTypes.join(',');
  if (arStatus && arStatus.length > 0) params.ar_status = arStatus.join(',');
  if (servingStates && servingStates.length > 0) params.serving_state = servingStates.join(',');
  if (archived) params.archived = archived;
  if (search) params.search = search;
  if (dateRangeStart) params.date_range_start = dateRangeStart;
  if (dateRangeEnd) params.date_range_end = dateRangeEnd;
  if (view) params.view = view;
  if (includeAr) params.include_ar = 'true';

  const url = `/web/studio/artists/${artistId}/marketing-campaigns`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
};
